

import React from 'react'

const PlayIcon = () => {
    return (
        <div>
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.9268 15.8825C25.311 16.0868 25.6324 16.3918 25.8565 16.7648C26.0806 17.1379 26.1991 17.5648 26.1991 18C26.1991 18.4352 26.0806 18.8622 25.8565 19.2352C25.6324 19.6082 25.311 19.9132 24.9268 20.1175L14.6775 25.691C13.0271 26.5894 11 25.4214 11 23.5742V12.4266C11 10.5786 13.0271 9.41146 14.6775 10.3082L24.9268 15.8825Z" fill="#8769BF"/>
            </svg>
        </div>
    )
}

export default PlayIcon

